var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carousel" },
    [
      _c(
        "agile",
        {
          ref: "carousel__main",
          staticClass: "carousel__main mb-3",
          attrs: { options: _vm.options1, "as-nav-for": _vm.asNavFor1 }
        },
        [
          _vm._l(_vm.slides, function(slide, index) {
            return _c(
              "div",
              { key: index, staticClass: "slide", class: "slide--" + index },
              [
                _vm.isSketchfab(slide)
                  ? _c("div", { staticClass: "embed-wrap" }, [
                      _c("iframe", {
                        staticStyle: { width: "100%", "aspect-ratio": "1 / 1" },
                        attrs: {
                          title: "Sketchfab model " + (index + 1),
                          frameborder: "0",
                          allowfullscreen: "",
                          mozallowfullscreen: "true",
                          webkitallowfullscreen: "true",
                          allow: "autoplay; fullscreen; xr-spatial-tracking",
                          "xr-spatial-tracking": "",
                          "execution-while-out-of-viewport": "",
                          "execution-while-not-rendered": "",
                          "web-share": "",
                          src: _vm.sketchfabEmbedUrl(slide)
                        }
                      })
                    ])
                  : _c("a", { attrs: { href: slide } }, [
                      _c("img", { attrs: { src: slide } })
                    ])
              ]
            )
          }),
          _vm._v(" "),
          _c("template", { slot: "prevButton" }, [
            _c("img", {
              attrs: { src: "/img/icons/chevron-left.svg", alt: "" }
            })
          ]),
          _vm._v(" "),
          _c("template", { slot: "nextButton" }, [
            _c("img", {
              attrs: { src: "/img/icons/chevron-right.svg", alt: "" }
            })
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "agile",
        {
          ref: "agile__thumbnails",
          staticClass: "agile__thumbnails",
          attrs: { options: _vm.options2, "as-nav-for": _vm.asNavFor2 }
        },
        _vm._l(_vm.slides, function(slide, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "slide slide--thumbnail",
              class: "slide--" + index,
              on: {
                click: function($event) {
                  return _vm.$refs.agile__thumbnails.goTo(index)
                }
              }
            },
            [
              _vm.isSketchfab(slide)
                ? [
                    _vm.sketchfabThumbs[index] && false
                      ? _c("img", {
                          attrs: {
                            src: _vm.sketchfabThumbs[index],
                            alt: "3D model thumbnail"
                          }
                        })
                      : _c(
                          "div",
                          {
                            staticClass: "thumb-3d",
                            attrs: { "aria-label": "3D model" }
                          },
                          [_vm._v("3D")]
                        )
                  ]
                : _c("img", { attrs: { src: slide } })
            ],
            2
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e11c4922", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e11c4922","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/Carousel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e11c4922","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/Carousel.vue
// module chunks = 0 1